<template>
  <div>
    <one-line-form :button="false" class="question">
      <input-field type="text" class="disabled invisible" />
      <h5>{{ i18n.t('residence:confirm') }}</h5>
    </one-line-form>
    <helper>{{ i18n.t('residence:hint') }}</helper>
    <action-bar v-if="showAnswers">
      <template slot="option">
        <a type="button" name="button" class="change" @click="toggleModal">{{ i18n.t('residence:other') }}</a>
      </template>
      <ul class="columns">
          <li @click="selectAnswer(answer)" :class="{ saving: isChoice }">
          <span>{{ i18n.t('country:' + answer) }}</span>
        </li>
      </ul>
    </action-bar>
    <modal :title="i18n.t('residence:residence')" v-if="showCountryModal" @closeModal="toggleModal" :highHeader="true">
      <country slot="body" :screenParams="screenParams" :onSelect="leaveScreen" ></country>
    </modal>
  </div>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/mixins';

  ul {
    @include button-list;
  }

  input {
    &::-webkit-input-placeholder {
      font-weight: 400;
    }
    &[disabled] {
      color: black;
    }

    border-bottom-color: transparent;
  }

  .input-wrapper.invisible{
    position: absolute;
  }

  .change {
    align-self: center;
    @include inputLink;
  }
</style>

<script>
  import Vue from 'vue'

  import { setSelection } from '../utils/selection'
  import { getNestedProperty } from '../utils/structure.js'
  import country from '../components/Country'

  export default Vue.component('country-screen', {
    components: {
      'country': country
    },
    props: ['screenParams'],
    mounted () {
      this.showAnswers = true
    },
    data () {
      const key = this.screenParams && this.screenParams.dispatchKey ? this.screenParams.dispatchKey.replace('update', '').toLowerCase() : 'user'
      const propertyName = (this.screenParams && this.screenParams.propertyName) || 'country'

      let propertyEntity = propertyName.split('.')
      propertyEntity = propertyEntity.length > 1 ? propertyEntity.slice(0, -1).join('.') : false
      const entityData = propertyEntity ? getNestedProperty(this.$store.state[key], propertyEntity) : this.$store.state.app

      const currentValue = entityData.country && entityData.country.code
      return {
        showAnswers: false,
        answer: currentValue,
        visibleQuestion: true,
        storeKey: key,
        propertyEntity: propertyEntity,
        propertyName: propertyName,
        dispatchKey: (this.screenParams && this.screenParams.dispatchKey) || 'updateUser',
        showCountryModal: false,
        answerSelected: false
      }
    },
    computed: {
      isChoice () {
        const entityData = this.propertyEntity ? getNestedProperty(this.$store.state[this.storeKey], this.propertyEntity) : this.$store.state[this.storeKey]

        return entityData.country === this.answer && this.answerSelected
      }
    },
    methods: {
      selectAnswer (answer) {
        this.answer = answer
        this.isSaving = true
        this.countryConfirmed = true

        let answerData = {}
        answerData[this.propertyName] = answer
        this.$store.dispatch(this.dispatchKey, answerData)

        this.leaveScreen()
      },
      toggleModal () {
        this.showCountryModal = !this.showCountryModal
      },
      leaveScreen (data) {
        const countryCodeUpdate = data && data.countryCode
        if (countryCodeUpdate) {
          this.answer = data.countryCode
        }

        this.showCountryModal = false
        this.answerSelected = true

        const input = this.$el.querySelector('input')
        if (input) {
          input.setAttribute('readonly', 'true')
          setSelection(input, { start: 0, end: 0 })
        }
        const app = this.$store.state.app
        const partner = this.$store.state.partner
        if (!partner.oneInputAddressCountries.includes(app.country.code) && app.country && !app.country.singlePostalCode && !app.country.postalCodePattern) {
          setTimeout(() => {
            this.$store.dispatch('next', this.screenParams.nextScreenRoute)
            this.showAnswers = false
          }, 500)
        }
      }
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/Residence.vue